import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=2f1f167e&scoped=true"
import script from "./properties.vue?vue&type=script&lang=js"
export * from "./properties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f167e",
  null
  
)

export default component.exports